import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Arkansas Blue Cross and Blue Shield",
  shortName: "Arkansas Blue Cross",
  slug: "arkansas-blue-cross-insurance",
  seoTitle:
    "Arkansas Blue Cross and Blue Shield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Arkansas Blue Cross and Blue Shield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Arkansas Blue Cross TMS coverage, Arkansas BCBS SPRAVATO authorization, Arkansas Blue Cross mental health benefits Coral Springs FL, Arkansas Blue Cross depression treatment Florida",
};

export const ArkansasBlueCrossInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default ArkansasBlueCrossInsurance;
